<template>
  <div class="personal">
    <div>
      <div class="search-box">
        <a-form-model layout="inline" :model="form" labelAlign="left">
          <div>
            <a-form-model-item label="门店">
              <a-select
                allowClear
                v-model="form.storeId"
                @change="getPerformanceList('isSearch')"
                placeholder="请选择部门"
              >
                <a-select-option v-for="item in deptList" :key="item.deptId" :value="item.deptId">
                  {{ item.deptName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item label="是否显示离职人员业绩">
              <a-select
                @change="getPerformanceList('isSearch')"
                v-model="form.isDimission"
                placeholder="是否显示离职人员业绩"
              >
                <a-select-option value="Y"> 是 </a-select-option>
                <a-select-option value="N"> 否 </a-select-option>
              </a-select>
            </a-form-model-item>
          </div>
          <div class="search-btns">
            <div class="search-date">
              <a-form-model-item label="日期">
                <a-date-picker
                  placeholder="开始日期"
                  @change="getPerformanceList('date')"
                  style="width: 138px"
                  v-model="form.startDate"
                />-
                <a-date-picker
                  placeholder="结束日期"
                  @change="getPerformanceList('date')"
                  style="width: 138px"
                  v-model="form.endDate"
                />
              </a-form-model-item>
              <a-button style="margin-left: 10px" @click="getPerformanceList">查询</a-button>
              <a-radio-group default-value="7" @change="getRadioDate" v-model="radioDate" button-style="solid">
                <a-radio-button value="7"> 本周 </a-radio-button>
                <a-radio-button value="30"> 本月 </a-radio-button>
                <a-radio-button value="90"> 本季 </a-radio-button>
                <a-radio-button value="365"> 本年 </a-radio-button>
              </a-radio-group>
            </div>
            <div>
              <a-button
                v-hasPermi="['statistics:comprehensiveStatistics:performanceExport']"
                icon="download"
                @click="getDownloadExcel"
              >
                导出
              </a-button>
            </div>
          </div>
        </a-form-model>
      </div>
      <div class="table-box" id="warpper_page_body" v-hasPermi="['statistics:comprehensiveStatistics:performanceList']">
        <a-table
          :loading="tableLoading"
          :columns="columns"
          bordered
          :data-source="performanceList"
          @change="handleChangeInTable"
          :pagination="pagination"
          :rowKey="
            (record, index) => {
              return index
            }
          "
        >
          <template slot="title" slot-scope="currentPageData">
            <div>总计：
              <span style="marginRight:20px">租单{{ totalObj.leaseOrders || 0 }} </span>
              <span style="marginRight:20px"> 售单{{ totalObj.saleCount || 0 }} </span>
              <span style="marginRight:20px"> 总单{{ totalObj.orders || 0 }} </span>
              <span style="marginRight:20px"> 业绩{{ totalObj.actualPayment || 0 }} </span>
              <span> 个人积分{{ totalObj.integral || 0 }}</span>
            </div>
          </template>
          <!-- :scroll="{ y: scrollHeight,x:1600 }" -->
          <template slot="index" slot-scope="text, item,index">
            <!-- <div v-if="item.rowName">{{ item.rowName || '' }}</div> -->
            <div >{{ index + 1 }}</div>
          </template>
          <template slot="integral" slot-scope="integral">
            <div v-hasPermi="['statistics:comprehensiveStatistics:integralTypeQuery']">{{ integral }}</div>
          </template>
          <template slot="teamName" slot-scope="text, item">
            <div style="margin: 7px 0" v-if="item.teamName && item.storeName">
              {{ item.teamName + '-' + item.storeName }}
            </div>
          </template>
        </a-table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { performanceStatistics, performanceListTotal } from '@/api/system/achievement/list'
import touristApi from '@/api/system/tourist/tourist'
import { getCurrentDate, getBeginWeek, getBeginMonth, getquarterDay, getYearFirstDay } from '@/utils/date'

const columns = [
  {
    title: '序号',
    align: 'center',
    width: 70,
    scopedSlots: { customRender: 'index' }
  },
  {
    title: '队-店',
    dataIndex: 'teamName',
    align: 'center',
    key: 1,
    width: 100,
    scopedSlots: { customRender: 'teamName' }
  },
  {
    title: '租单',
    align: 'center',
    dataIndex: 'leaseOrders',
    sorter: true,
    width: 100,
    key: 2,
    scopedSlots: { customRender: 'leaseOrders' }
  },
  {
    title: '售单',
    align: 'center',
    dataIndex: 'saleCount',
    sorter: true,
    width: 100,
    key: 7,
    scopedSlots: { customRender: 'saleCount' }
  },
  {
    title: '总单',
    dataIndex: 'orders',
    align: 'center',
    scopedSlots: { customRender: 'orders' },
    sorter: true,
    width: 100,
    key: 3
  },
  {
    title: '业绩',
    align: 'center',
    dataIndex: 'actualPayment',
    scopedSlots: { customRender: 'actualPayment' },
    sorter: true,
    width: 150,
    key: 4
  },
  // {
  //   title: '应收业绩',
  //   dataIndex: 'receivable',
  //   align: 'center',
  //   scopedSlots: { customRender: 'receivable' },
  //   sorter: true,
  //   width: 150,
  //   key: 5
  // },
  // {
  //   title: '实收业绩(租)',
  //   align: 'center',
  //   dataIndex: 'act',
  //   scopedSlots: { customRender: 'actualPaymentRent' },
  //   sorter: true,
  //   width: 150,
  //   key: 7
  // },
  // {
  //   title: '应收业绩(租)',
  //   dataIndex: 'receivable',
  //   align: 'center',
  //   scopedSlots: { customRender: 'receivableRent' },
  //   sorter: true,
  //   width: 150,
  //   key: 8
  // },
  //  {
  //   title: '实收业绩(售)',
  //   align: 'center',
  //   dataIndex: 'act',
  //   scopedSlots: { customRender: 'actualPaymentSale' },
  //   sorter: true,
  //   width: 150,
  //   key: 9
  // },
  // {
  //   title: '应收业绩(售)',
  //   dataIndex: 'receivable',
  //   align: 'center',
  //   scopedSlots: { customRender: 'receivableSale' },
  //   sorter: true,
  //   width: 150,
  //   key: 10
  // },
  {
    title: '个人积分',
    align: 'center',
    dataIndex: 'integral',
    scopedSlots: { customRender: 'integral' },
    sorter: true,
    width: 150,
    key: 6
  }
  // {
  //   title: '个人积分(租)',
  //   align: 'center',
  //   dataIndex: 'integralRent',
  //   scopedSlots: { customRender: 'integralRent' },
  //   sorter: true,
  //   width: 150,
  //   key: 12
  // },
  //  {
  //   title: '个人积分(售)',
  //   align: 'center',
  //   dataIndex: 'integralSale',
  //   scopedSlots: { customRender: 'integralSale' },
  //   sorter: true,
  //   width: 150,
  //   key: 13
  // }
]
export default {
  data () {
    return {
      scrollHeight: 1000,
      form: {
        isAllot: undefined,
        storeId: undefined,
        startDate: '',
        endDate: '',
        listType: '2',
        performanceStatisticsSort: '4',
        sortType: 'DESC',
        isDimission: 'N'
      },
      // contractCode: undefined,
      isuser: false,
      deptList: [], // 门店下拉列表
      userList: [],
      data: [],
      columns,
      radioDate: '7',
      performanceList: [],
      tableLoading: false,
      // 分页参数
      pagination: {
        current: 1,
        pageSize: this.$getters.pageSize,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        showQuickJumper: false,
        showSizeChanger: true,
        total: 0
      },
      totalObj: {} // 总计
    }
  },
  mounted () {
    // window.addEventListener('scroll', this.menu)
  },
  methods: {
    getTotal (params) {
      performanceListTotal(params).then(res => {
        if (res.code === 200) {
          this.totalObj = res.data
          this.totalObj.name = '总计'
          // let index = this.performanceList.findIndex(el=>el.name == '总计')
          // if(index >= 0){
          //   return
          // }
          // this.performanceList.unshift(this.totalObj)
          this.performanceList.forEach(el => {
            el.uuid = new Date().getTime() + '' + Math.random()
          })

          // console.log(this.performanceList,'this.performanceList')
        }
      })
    },
    menu () {
      const FIXOBJ = document.getElementById('warpper_page_body')
      const LIMITTOP = FIXOBJ.offsetTop
      this.scroll = document.documentElement.scrollTop || document.body.scrollTop
      const CONH = document.body.clientHeight - 350
      if (this.scroll >= LIMITTOP) {
        this.scrollHeight = CONH || 600
      }
    },
    // 部门下拉列表
    getDeptList () {
      touristApi.getDeptList().then((res) => {
        const { code, data } = res
        if (code === 200) {
          this.deptList = data.filter((item) => {
            return item.deptLev === '1'
          })
        }
      })
    },
    // 获取以往时间值
    getRadioDate () {
      this.tableLoading = true
      let startTime = ''
      const endTime = this.$moment(getCurrentDate()).format('YYYY-MM-DD')
      // 判断日期做了点击按钮禁止改为能点击
      switch (this.radioDate) {
        // 当前一天的时间
        case '7':
          startTime = this.$moment(getBeginWeek()).format('YYYY-MM-DD')
          break
        // 一个季度
        case '30':
          startTime = this.$moment(getBeginMonth()).format('YYYY-MM-DD')
          break
        // 季度时间
        case '90':
          startTime = this.$moment(getquarterDay()).format('YYYY-MM-DD')
          break
        // 一年的时间
        case '365':
          startTime = this.$moment(getYearFirstDay()).format('YYYY-MM-DD')
          break
        default:
          startTime = this.$moment(getBeginWeek()).format('YYYY-MM-DD')
      }
      this.form.startDate = startTime
      this.form.endDate = endTime
      setTimeout((_) => {
        this.getPerformanceList()
      }, 500)
    },
    // 列表
    getPerformanceList (e) {
      console.log(this.form, '门店')
      const params = this.form
      if (e) {
        if (e === 'date') {
          if (!this.form.startDate || !this.form.endDate) {
            this.$message.error('请填写开始日期或结束日期')
            return
          } else {
            params.startDate = moment(this.form.startDate).format('YYYY-MM-DD')
            params.endDate = moment(this.form.endDate).format('YYYY-MM-DD')
          }
        }
        this.pagination.current = 1
      }
      this.tableLoading = true

      params.pageNum = this.pagination.current
      params.pageSize = this.pagination.pageSize
      performanceStatistics(params).then((res) => {
        this.tableLoading = false
        if (res.code === 200) {
          // let obj = res.data.counts
          // obj.rowName = '总计'
          // let arr = params.pageNum == 1 ? [obj] : []
          // this.performanceList = [...arr, ...(res.data.page.records || [])]
          this.performanceList = res.data.records
          this.performanceList.forEach((item) => {
            item.cName = item.name
            // this.performanceList = this.performanceList.push({ cName: item.name,keyindex:1 })
          })
          // this.performanceList.push(Cname:)
          this.pagination.total = res.data.total
          // this.pagination.total = res.data.page.total
          this.getTotal(params)

          console.log(this.performanceList, '小组列表')
        }
      })
    },
    handleChangeInTable (pagination, filters, sorter) {
      // 分页、排序、筛选变化时触发
      if (sorter) {
        console.log(sorter)
        if (sorter.order === 'ascend') {
          this.form.sortType = 'ASC'
          console.log(this.form.sortType)
        } else {
          this.form.sortType = 'DESC'
        }
        this.form.performanceStatisticsSort = sorter.columnKey ? sorter.columnKey : this.form.performanceStatisticsSort
        this.pagination = pagination
        this.getPerformanceList()
      }
    },
    getDownloadExcel () {
      const that = this
      that.downloadPost('comprehensiveStatistics/performanceExport', { ...that.form }, `p_${new Date().getTime()}.xlsx`)
    }
  },
  created () {
    this.getDeptList()
    this.getRadioDate()
    this.getPerformanceList()
    console.log(this.radioDate)
  }
}
</script>
<style lang="less" scoped>
@import './index.less';
.name-box {
  width: 60px;
  height: 60px;
  line-height: 40px;
  font-weight: 700;
  background-color: var(--ThemeColor);
  border-radius: 50%;
  font-size: 12px;
  padding: 4px;
  color: #fff;
  padding-top: 7px;
  overflow: hidden; //超出宽度部分隐藏
  text-overflow: ellipsis;
  word-break: break-all; /* 内容自动换行 */
}
</style>
